<script setup>
import { ref, watch, computed, onMounted } from "vue";
import {
  Chart,
  ArcElement,
  Tooltip,
  Legend,
  Title,
  DoughnutController // Import the DoughnutController
} from "chart.js";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  title: String
});

// LRR
const chartColors = {
  default: {
    primary: "#00D1B2",
    info: "#209CEE",
    danger: "#FF3860",
  },
};
const labels = props.data.label;
const data = props.data.data;
const color = props.data.color;

const datasetObject = () => {
  return {
    label: 'GB ',
    backgroundColor: color,
    data: data,
  };
};
// Fin LRR

const root = ref(null);

let chart;

Chart.register(
  ArcElement,
  Tooltip,
  Legend,
  Title,
  DoughnutController // Register the DoughnutController
);

onMounted(() => {
  chart = new Chart(root.value, {
    type: "doughnut",
    data: { 
      labels,
      datasets: [
        datasetObject(),
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: props.title
        }
      },
    },
  });
});

const chartData = computed(() => props.data);

watch(chartData, (data) => {
  if (chart) {
    chart.data = data;
    chart.update();
  }
});
</script>

<template>
  <canvas ref="root" />
</template>
